<div class="main-container">
  <div fxLayout="row" fxLayoutAlign="start center" class="header-container grad-purple">
    <button mat-icon-button mat-button (click)="close()" aria-label="Close send email panel">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <h3>
      <span class="title">{{ title }}</span>
    </h3>
  </div>
  <div class="content-container">
    <app-compose-email
      [emailType]="emailType"
      [recipientPersonId]="recipientPersonId"
      [emailCustomizationInput]="emailCustomization"
      (composedEmailForm)="onComposeEmailComplete($event)"
    >
    </app-compose-email>
    <span>
      <mat-icon *ngIf="isRecipientInvalid">warning</mat-icon>
      {{ footer }}
    </span>
    <div class="email-buttons" fxLayout fxLayoutGap="10px">
      <button mat-raised-button color="primary" [disabled]="!isValid()" (click)="send()">Send email now</button>
      <button mat-raised-button class="mat-secondary-button" (click)="close()">Cancel</button>
    </div>
  </div>
</div>
